/**
 * @flow
 * @relayHash 1addcfe98b6e2dd60ff9af94a47b8aef
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BrandsQueryVariables = {||};
export type BrandsQueryResponse = {|
  +list_brands: $ReadOnlyArray<?{|
    +id: string,
    +ref_id: string,
    +name: ?string,
    +logo_url: ?string,
  |}>
|};
export type BrandsQuery = {|
  variables: BrandsQueryVariables,
  response: BrandsQueryResponse,
|};
*/


/*
query BrandsQuery {
  list_brands {
    id
    ref_id
    name
    logo_url
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "list_brands",
    "storageKey": null,
    "args": null,
    "concreteType": "Brand",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "ref_id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "logo_url",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "BrandsQuery",
  "id": null,
  "text": "query BrandsQuery {\n  list_brands {\n    id\n    ref_id\n    name\n    logo_url\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "BrandsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": v0
  },
  "operation": {
    "kind": "Operation",
    "name": "BrandsQuery",
    "argumentDefinitions": [],
    "selections": v0
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c99ccf9a27bf5e73a12cbe3ac52ada2f';
module.exports = node;
